import { render, staticRenderFns } from "./data66.vue?vue&type=template&id=1fb70cd0&scoped=true&"
import script from "./data66.vue?vue&type=script&lang=js&"
export * from "./data66.vue?vue&type=script&lang=js&"
import style1 from "./data66.vue?vue&type=style&index=1&id=1fb70cd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb70cd0",
  null
  
)

export default component.exports